export default "__VITE_ASSET__694b8d54__"